
import { Input, DatePicker, Table, Pagination } from 'antd';
import apiClient from '../../Api/apiClient';
import WithdrawModal from '../../Modals/WithdrawModal';
import dayjs from 'dayjs';
import React, { useState, useEffect } from "react";


const { Search } = Input;

const HistoryAffiliate = () => {
  const [tenders, setTenders] = useState([]);
  const [selectedTenReqId, setSelectedTenReqId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [page, setPage] = useState(1);
  const [totalAmount, setTotalAmount] = useState("0.00");
  const [total, setTotal] = useState(0);
  const limit = 5;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formattedDate = selectedDate
          ? dayjs(selectedDate).format("YYYY-MM-DD")
          : "";

        const apiUrl = `/affiliator/tender-request/account-history?key=${searchKey}&tender_published_date=${formattedDate}&limit=${limit}&skip=${(page - 1) * limit
          }`;

        const response = await apiClient.get(apiUrl);

        if (response.data.success && response.data.data) {
          const formattedData = response.data.data.map((item, index) => ({
            key: index + 1 + (page - 1) * limit,
            ten_req_id: item.ten_req_id || "N/A",
            tender_name: item.tender_name || "N/A",
            company_name: item.company_name || "N/A",
            amount: `BDT ${item.comission_amount || "0.00"} `,
            date: item.tender_published_date || "N/A",
            withdraw_status: item.withdraw_status || "Pending",
          }));

          setTenders(formattedData);
          setTotal(response.data.total || 0);
          setTotalAmount(response.data.total_amount || "0.00");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [page, searchKey, selectedDate]);

  const handleOpenModal = (tenReqId) => {
    setSelectedTenReqId(tenReqId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTenReqId(null);
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value.trim());
    setPage(1);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setPage(1);
  };

  const columns = [
    { title: "S/N", dataIndex: "key", key: "key" },
    { title: "Tender Name", dataIndex: "tender_name", key: "tender_name" },
    { title: "Request Id", dataIndex: "ten_req_id", key: "ten_req_id" },
    { title: "Company Name", dataIndex: "company_name", key: "company_name" },
    { title: "Earned Amount", dataIndex: "amount", key: "amount" },
    { title: "Published Date", dataIndex: "date", key: "date" },
    {
      title: "Withdraw Status",
      dataIndex: "withdraw_status",
      key: "withdraw_status",
      render: (status, record) => {
        const publishedDate = dayjs(record.date);
        const today = dayjs();
        const isAfter15Days = today.diff(publishedDate, "day") >= 15;

        if (status && status !== "pending") {
          return (
            <span
              className={`px-2 py-1 text-xs font-semibold rounded capitalize ${status === "review"
                ? "bg-yellow-100 text-yellow-600"
                : status === "cancel"
                  ? "bg-red-100 text-red-600"
                  : status === "paid"
                    ? "bg-green-100 text-green-600"
                    : "bg-gray-200 text-gray-700"
                }`}
            >
              {status}
            </span>
          );
        }

        if (isAfter15Days) {
          return (
            <button
              className="px-2 py-1 text-xs font-semibold rounded bg-blue-500 text-white"
              onClick={() => handleOpenModal(record.ten_req_id)}
            >
              Withdraw
            </button>
          );
        }

        return (
          <span className="px-2 py-1 text-xs font-semibold rounded bg-gray-200 text-gray-700">
            {status || "pending"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="container mx-auto p-4 mt-[150px]">
      <div className="flex flex-col md:flex-row justify-between mb-4">
        <h3 className="text-[24px] leading-[50px] font-[600] tracking-[0.2px] text-center font-poppins md:mb-0 mb-2">
          Accounts History <span className="text-lg">(Total={total})</span>
        </h3>

        <div className="flex flex-wrap gap-4 justify-center mb-6">
          <Search
            placeholder="Search by key"
            allowClear
            size="large"
            className="w-[300px]"
            value={searchKey}
            onChange={handleSearch}
          />

          <DatePicker
            format="YYYY-MM-DD"
            onChange={handleDateChange}
            size="large"
            className="w-[300px]"
            placeholder="Select Publish Date"
          />
        </div>
      </div>

      {/* Table for Larger Devices */}
      <div className="hidden md:block">
        <Table
          columns={columns}
          dataSource={tenders}
          pagination={false}
          bordered
          className="shadow-md [&_.ant-table-thead>tr>th]:bg-DefaultColor [&_.ant-table-thead>tr>th]:text-white"
        />
      </div>

      {/* Card Layout for Smaller Devices */}
      <div className="md:hidden">
        {tenders.map((tender) => (
          <div
            key={tender.key}
            className="bg-white shadow-md rounded-lg p-4 mb-4"
          >
            <div className="grid grid-cols-2 gap-2">
              <div className="font-bold">S/N</div>
              <div>{tender.key}</div>

              <div className="font-bold">Tender Name</div>
              <div>{tender.tender_name}</div>

              <div className="font-bold">Request Id</div>
              <div>{tender.ten_req_id}</div>

              <div className="font-bold">Company Name</div>
              <div>{tender.company_name}</div>

              <div className="font-bold">Earned Amount</div>
              <div>{tender.amount}</div>

              <div className="font-bold">Published Date</div>
              <div>{tender.date}</div>

              <div className="font-bold">Withdraw Status</div>
              <div>
                {columns[6].render(tender.withdraw_status, tender)}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-4 md:ml-20">
        <span className="text-lg font-semibold">
          Total Earned Amount:{" "}
          <span className="text-blue-600">{totalAmount}</span>
        </span>
      </div>

      <div className="flex justify-center mt-4">
        <Pagination
          current={page}
          pageSize={limit}
          total={total}
          onChange={(page) => setPage(page)}
          showSizeChanger={false}
        />
      </div>

      {isModalOpen && selectedTenReqId && (
        <WithdrawModal
          isOpen={isModalOpen}
          tenReqId={selectedTenReqId}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default HistoryAffiliate;

// import { useEffect, useState } from 'react';
// import { Input, DatePicker, Table, Pagination } from 'antd';
// import apiClient from '../../Api/apiClient';
// import WithdrawModal from '../../Modals/WithdrawModal';
// import dayjs from 'dayjs';

// const { Search } = Input;

// const HistoryAffiliate = () => {
//   const [tenders, setTenders] = useState([]);
//   const [selectedTenReqId, setSelectedTenReqId] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [searchKey, setSearchKey] = useState('');
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [page, setPage] = useState(1);
//   const [totalAmount, setTotalAmount] = useState('0.00');
//   const [total, setTotal] = useState(0);
//   const limit = 5;

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const formattedDate = selectedDate
//           ? dayjs(selectedDate).format('YYYY-MM-DD')
//           : '';

//         const apiUrl = `/affiliator/tender-request/account-history?key=${searchKey}&tender_published_date=${formattedDate}&limit=${limit}&skip=${
//           (page - 1) * limit
//         }`;

//         const response = await apiClient.get(apiUrl);
//         //  console.log('API Response:', response.data);

//         if (response.data.success && response.data.data) {
//           const formattedData = response.data.data.map((item, index) => ({
//             key: index + 1 + (page - 1) * limit,
//             ten_req_id: item.ten_req_id || 'N/A',
//             tender_name: item.tender_name || 'N/A',
//             company_name: item.company_name || 'N/A',
//             amount: `BDT ${item.comission_amount || '0.00'} `,
//             date: item.tender_published_date || 'N/A',
//             withdraw_status: item.withdraw_status || 'Pending',
//           }));

//           setTenders(formattedData);
//           setTotal(response.data.total || 0);
//           setTotalAmount(response.data.total_amount || '0.00');
//         }
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };

//     fetchData();
//   }, [page, searchKey, selectedDate]);

//   const handleOpenModal = tenReqId => {
//     setSelectedTenReqId(tenReqId);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedTenReqId(null);
//   };

//   const handleSearch = e => {
//     setSearchKey(e.target.value.trim());
//     setPage(1);
//   };

//   const handleDateChange = date => {
//     setSelectedDate(date);
//     setPage(1);
//   };

//   const columns = [
//     { title: 'S/N', dataIndex: 'key', key: 'key' },
//     { title: 'Tender Name', dataIndex: 'tender_name', key: 'tender_name' },
//     { title: 'Request Id', dataIndex: 'ten_req_id', key: 'ten_req_id' },
//     { title: 'Company Name', dataIndex: 'company_name', key: 'company_name' },
//     { title: 'Earned Amount', dataIndex: 'amount', key: 'amount' },
//     { title: 'Published Date', dataIndex: 'date', key: 'date' },
//     {
//       title: 'Withdraw Status',
//       dataIndex: 'withdraw_status',
//       key: 'withdraw_status',
//       render: (status, record) => {
//         const publishedDate = dayjs(record.date);
//         const today = dayjs();
//         const isAfter15Days = today.diff(publishedDate, 'day') >= 15;

//         // If withdraw status exists, display status instead of button
//         if (status && status !== 'pending') {
//           return (
//             <span
//               className={`px-2 py-1 text-xs font-semibold rounded capitalize ${
//                 status === 'review'
//                   ? 'bg-yellow-100 text-yellow-600'
//                   : status === 'cancel'
//                   ? 'bg-red-100 text-red-600'
//                   : status === 'paid'
//                   ? 'bg-green-100 text-green-600'
//                   : 'bg-gray-200 text-gray-700'
//               }`}
//             >
//               {status}
//             </span>
//           );
//         }

//         // If no withdraw request yet and 15+ days have passed, show Withdraw button
//         if (isAfter15Days) {
//           return (
//             <button
//               className="px-2 py-1 text-xs font-semibold rounded bg-blue-500 text-white"
//               onClick={() => handleOpenModal(record.ten_req_id)}
//             >
//               Withdraw
//             </button>
//           );
//         }

//         // Otherwise, display status
//         return (
//           <span className="px-2 py-1 text-xs font-semibold rounded bg-gray-200 text-gray-700">
//             {status || 'pending'}
//           </span>
//         );
//       },
//     },
//   ];


//   // const columns = [
//   //   { title: 'S/N', dataIndex: 'key', key: 'key' },
//   //   { title: 'Tender Name', dataIndex: 'tender_name', key: 'tender_name' },
//   //   { title: 'Request Id', dataIndex: 'ten_req_id', key: 'ten_req_id' },
//   //   { title: 'Company Name', dataIndex: 'company_name', key: 'company_name' },
//   //   { title: 'Earned Amount', dataIndex: 'amount', key: 'amount' },
//   //   { title: 'Published Date', dataIndex: 'date', key: 'date' },
//   //   {
//   //     title: 'Withdraw Status',
//   //     dataIndex: 'withdraw_status',
//   //     key: 'withdraw_status',
//   //     render: (status, record) => {
//   //       const publishedDate = dayjs(record.date);
//   //       const today = dayjs();
//   //       const isAfter15Days = today.diff(publishedDate, 'day') >= 15;

//   //       if (isAfter15Days) {
//   //         return (
//   //           <button
//   //             className="px-2 py-1 text-xs font-semibold rounded bg-blue-500 text-white"
//   //             onClick={() => handleOpenModal(record.ten_req_id)}
//   //           >
//   //             Withdraw
//   //           </button>
//   //         );
//   //       }

//   //       return (
//   //         <span
//   //           className={`px-2 py-1 text-xs font-semibold rounded ${
//   //             status === 'pending'
//   //               ? 'bg-gray-200 text-gray-700'
//   //               : status === 'review'
//   //               ? 'bg-yellow-100 text-yellow-600'
//   //               : status === 'cancel'
//   //               ? 'bg-red-100 text-red-600'
//   //               : status === 'paid'
//   //               ? 'bg-green-100 text-green-600'
//   //               : 'bg-blue-100 text-blue-600'
//   //           }`}
//   //         >
//   //           {status}
//   //         </span>
//   //       );
//   //     },
//   //   },
//   // ];

//   return (
//     <div className="container mx-auto p-4 mt-[150px]">
//       <div className="flex flex-col md:flex-row justify-between mb-4">
//         <h3 className="text-[24px] leading-[50px] font-[600] tracking-[0.2px] text-center font-poppins md:mb-0 mb-2">
//           Accounts History <span className='text-lg'>(Total={total})</span>
//         </h3>

//         <div className="flex flex-wrap gap-4 justify-center mb-6">
//           <Search
//             placeholder="Search by key"
//             allowClear
//             size="large"
//             className="w-[300px]"
//             value={searchKey}
//             onChange={handleSearch} // Trigger search on change
//           />

//           <DatePicker
//             format="YYYY-MM-DD"
//             onChange={handleDateChange}
//             size="large"
//             className="w-[200px]"
//             placeholder="Select Publish Date"
//           />
//         </div>
//       </div>

//       <Table
//         columns={columns}
//         dataSource={tenders}
//         pagination={false}
//         bordered
//         className="shadow-md [&_.ant-table-thead>tr>th]:bg-DefaultColor [&_.ant-table-thead>tr>th]:text-white"
//       />

//       <div className="flex justify-center mt-4 md:ml-20">
//         <span className="text-lg font-semibold">
//           Total Earned Amount:{' '}
//           <span className="text-blue-600">{totalAmount}</span>
//         </span>
//       </div>

//       <div className="flex justify-center mt-4">
//         <Pagination
//           current={page}
//           pageSize={limit}
//           total={total}
//           onChange={page => setPage(page)}
//           showSizeChanger={false}
//         />
//       </div>

//       {isModalOpen && selectedTenReqId && (
//         <WithdrawModal
//           isOpen={isModalOpen}
//           tenReqId={selectedTenReqId}
//           onClose={handleCloseModal}
//         />
//       )}
//     </div>
//   );
// };

// export default HistoryAffiliate;


// import { useEffect, useState } from 'react';
// import apiClient from '../../Api/apiClient';
// import WithdrawModal from '../../Modals/WithdrawModal';

// const HistoryAffiliate = () => {
//   const [tenders, setTenders] = useState([]);
//   const [selectedTenReqId, setSelectedTenReqId] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await apiClient.get(
//           '/affiliator/tender-request/account-history'
//         );

//         console.log('Account History Response:', response.data);

//         if (response.data.success && response.data.data) {
//           const formattedData = response.data.data.map((item, index) => {
//             // Handle cases where published date is null
//             let status = 'Pending';
//             if (item.tender_published_date) {
//               const publishedDate = item.tender_published_date;
//               // const publishedDate = new Date(item.tender_published_date);
//               const currentDate = new Date();
//               const diffTime = Math.abs(currentDate - publishedDate);
//               const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//               status = diffDays <= 15 ? 'Withdraw' : 'Pending';
//             }

//             return {
//               id: index + 1,
//               ten_req_id: item.ten_req_id || 'N/A',
//               tender_name: item.tender_name || 'N/A',
//               company_name: item.company_name || 'N/A',
//               amount: item.amount || '0.00',
//               date: item.tender_published_date || 'N/A',
//               status,
//             };
//           });

//           setTenders(formattedData);
//         }
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleOpenModal = tenReqId => {
//     setSelectedTenReqId(tenReqId);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedTenReqId(null);
//   };

//   const statusColors = {
//     Open: 'bg-blue-100 text-blue-600',
//     Withdraw: 'bg-green-100 text-green-600',
//     Pending: 'bg-red-100 text-red-600',
//   };

//   return (
//     <div className="container mx-auto p-4 mt-[150px]">
//       <div className="flex justify-center mb-4">
//         <h3 className="text-[24px] leading-[50px] font-[600] tracking-[0.2px] text-center font-poppins">
//           Accounts History
//         </h3>
//       </div>

//       <div className="overflow-x-auto">
//         <div className="overflow-hidden md:rounded-lg">
//           <table className="min-w-full text-sm text-left border border-gray-200">
//             <thead className="bg-blue-600 text-white uppercase">
//               <tr>
//                 <th className="px-4 py-3">S/N</th>
//                 <th className="px-4 py-3">Tender Name</th>
//                 <th className="px-4 py-3">Request Id</th>
//                 <th className="px-4 py-3">Company Name</th>
//                 <th className="px-4 py-3">Earned Amount</th>
//                 <th className="px-4 py-3">Published Date</th>
//                 <th className="px-4 py-3">Status</th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {tenders.length > 0 ? (
//                 tenders.map(tender => (
//                   <tr key={tender.id} className="hover:bg-gray-100">
//                     <td className="px-4 py-3">{tender.id}</td>
//                     <td className="px-4 py-3">{tender.tender_name}</td>
//                     <td className="px-4 py-3">{tender.ten_req_id}</td>
//                     <td className="px-4 py-3">{tender.company_name}</td>
//                     <td className="px-4 py-3 font-bold">{tender.amount}</td>
//                     <td className="px-4 py-3">{tender.date}</td>
//                     <td className="px-4 py-3">
//                       <button
//                         className={`px-2 py-1 text-xs font-semibold rounded ${
//                           statusColors[tender.status] ||
//                           'bg-gray-100 text-gray-600'
//                         } ${
//                           tender.status === 'Pending'
//                             ? 'cursor-not-allowed opacity-50'
//                             : ''
//                         }`}
//                         onClick={() =>
//                           tender.status === 'Withdraw' &&
//                           handleOpenModal(tender.ten_req_id)
//                         }
//                         disabled={tender.status === 'Pending'}
//                       >
//                         {tender.status}
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="6" className="text-center py-4">
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Withdraw Modal */}
//       {isModalOpen && selectedTenReqId && (
//         <WithdrawModal
//           isOpen={isModalOpen}
//           tenReqId={selectedTenReqId}
//           onClose={handleCloseModal}
//         />
//       )}
//     </div>
//   );
// };

// export default HistoryAffiliate;
